import { render, staticRenderFns } from "./InformacoesPessoais.vue?vue&type=template&id=66db9a65&lang=pug"
import script from "./InformacoesPessoais.vue?vue&type=script&lang=js"
export * from "./InformacoesPessoais.vue?vue&type=script&lang=js"
import style0 from "./InformacoesPessoais.vue?vue&type=style&index=0&id=66db9a65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports